import { cn } from "@/lib/utils";

export const Overline = ({ children, className = "" }) => (
  <span
    className={cn(
      "inline-block text-xs md:text-sm uppercase tracking-[0.22em] font-semibold text-gold",
      className
    )}
  >
    {children}
  </span>
);

export const SectionHeading = ({
  overline,
  title,
  description,
  align = "left",
  className = "",
  titleClassName = "",
}) => (
  <div
    className={cn(
      "max-w-3xl",
      align === "center" && "mx-auto text-center",
      className
    )}
  >
    {overline && <Overline className="mb-4">{overline}</Overline>}
    {title && (
      <h2
        className={cn(
          "font-serif text-3xl md:text-4xl lg:text-5xl tracking-tight leading-tight text-charcoal font-medium text-balance",
          titleClassName
        )}
      >
        {title}
      </h2>
    )}
    {description && (
      <p className="mt-5 text-base md:text-lg leading-relaxed font-light text-slatey">
        {description}
      </p>
    )}
  </div>
);

export default SectionHeading;
